import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Dashboard.css';

const Dashboard = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Configure axios with CORS support
const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

  useEffect(() => {
    fetchMatches();
    const interval = setInterval(fetchMatches, 10000);
    return () => clearInterval(interval);
  }, []);

  const fetchMatches = async () => {
    try {
      const response = await api.get('/getCricketMatches');
      console.log('Matches response:', response.data);
      if (response.data && response.data.sport && response.data.sport.body) {
        setMatches(response.data.sport.body);
      }
      setError(null);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching matches:', error);
      setError('Failed to load matches. Please make sure the backend server is running.');
      setLoading(false);
    }
  };

  const getStatusColor = (status, inPlay) => {
    if (inPlay) return 'status-live';
    if (status === 'OPEN') return 'status-open';
    return 'status-suspended';
  };

  if (loading) return <div className="loading">Loading matches...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="dashboard">
      <h2>Live & Upcoming Matches</h2>
      {matches.length === 0 ? (
        <div className="no-matches">No matches available. Create a match from the Manage Matches page.</div>
      ) : (
        <div className="matches-grid">
          {matches.map(match => (
            <div key={match.marketid} className="match-card">
              <div className="match-header">
                <h3>{match.matchName}</h3>
                <span className={`status-badge ${getStatusColor(match.status, match.inPlay)}`}>
                  {match.inPlay ? 'LIVE' : match.status}
                </span>
              </div>
              <div className="match-teams">
                <div className="team-info">
                  <strong>{match.cname}</strong>
                  {match.inPlay && (
                    <div className="odds">
                      Odds: {match.b1 || 'N/A'} / {match.b2 || 'N/A'}
                    </div>
                  )}
                </div>
              </div>
              <div className="match-footer">
                <small>Market ID: {match.marketid}</small>
                <small>Date: {new Date(match.matchdate).toLocaleString()}</small>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dashboard;